import React, { FC } from 'react';
import { IoCloseSharp } from 'react-icons/io5';

import { ActionIcon } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';

import { FeatureKey } from 'models';

import { AccessGranted } from 'components/component-chat/screens/AccessGranted';
import { RequestAccess } from 'components/component-chat/screens/RequestAccess';
import { useCurrentUser } from 'hooks/use-current-user';
import { useFeatureAccess } from 'hooks/use-feature-access';

import classes from './styles.module.scss';

const AIAccessModal: FC<ContextModalProps> = ({ context, id }) => {
    const user = useCurrentUser();
    const hasAiAccess = useFeatureAccess(FeatureKey.ARTIFICIAL_INTELLIGENCE);

    return user ? (
        <>
            <ActionIcon className={classes.aiClose} size="sm" variant={'subtle'} onClick={() => context.closeModal(id)}>
                <IoCloseSharp size={16} strokeWidth={1.5} />
            </ActionIcon>
            {hasAiAccess && <AccessGranted />}
            {<RequestAccess />}
        </>
    ) : null;
};

export { AIAccessModal };
